// extracted by mini-css-extract-plugin
export var container = "ImageAndText-module--container--c4294";
export var doubleImageContainer = "ImageAndText-module--doubleImageContainer--428be";
export var imageFirst = "ImageAndText-module--imageFirst--e19bb";
export var textRight = "ImageAndText-module--textRight--05700";